import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { Form, Input } from 'antd';

function TextAreaField(props) {
  const { name, label, type, formItemLayout, ...restInputProps } = props;
  // eslint-disable-next-line
  const [field, meta, helpers] = useField(name);
  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      // hasFeedback
      help={meta.touched && meta.error}
      validateStatus={meta.touched && meta.error && 'error'}
    >
      <Input.TextArea
        {...field}
        onChange={(val) => helpers.setValue(val.target.value)}
        type={type} {...restInputProps}
        size="large"
      />
    </Form.Item>
  );
}

TextAreaField.defaultProps = {
  formItemLayout: {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  },
};

const { shape, string } = PropTypes;

TextAreaField.propTypes = {
  name: string.isRequired,
  label: string,
  formItemLayout: shape({}),
};

export default TextAreaField;
